export default {
  CONTROL: 'control',
  V1: 'variant1',
  V2: 'variant2',
  V3: 'variant3',
  V4: 'variant4',
}
